/**
 * Group
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useApi2call } from 'containers/Api2/index.js';
import AvatarWithText from 'components/media/AvatarWithText/index.jsx';
import DeleteButton from 'components/interaction/DeleteButton/index.jsx';
import { GROUPKEYS_BY_TYPE } from 'containers/User/constants.js';
import messages from '../messages.js';

function Group(props) {
  const { group, user, onChange } = props;
  const api2call = useApi2call();
  const confirmRemoveFromGroup = { ...messages.confirmRemoveFromGroup, values: group };
  const link = `/admin/groups/${group.typeName}/${group.id}`;
  const typeMessageKey = `${GROUPKEYS_BY_TYPE[group.groupType]}Label`;
  async function handleDelete() {
    await api2call({
      method: 'DELETE',
      url: `sa/groups/${group.id}/members/${user.roleType}/${user.id}`,
      selector: `sa/users/${user.typeName}/${user.id}/groups/${group.id}`,
      version: 2,
      withPromise: true,
    });
    if (onChange) {
      onChange();
    }
  }

  return (
    <div className="d-flex align-items-center">
      <div className="flex-grow-1 d-sm-flex align-items-center">
        <Link to={link}>
          <AvatarWithText group color={group.theme.themeColor.hex} align="center">
            {group.name}
          </AvatarWithText>
        </Link>
        {group.dependencies.length > 0 && (
          <div className="small text-muted ms-2 ms-sm-3">
            {group.dependencies.map((d) => d.name).join(', ')}
          </div>
        )}
      </div>
      <div className="d-flex align-items-center">
        <span className="small text-muted">
          <FormattedMessage {...messages[typeMessageKey]} />
        </span>
        <DeleteButton
          disabled={!group.canDelete}
          disabledIcon="ss-lock"
          onClick={handleDelete}
          confirmText={confirmRemoveFromGroup}
          confirmLabel={messages.removeFrom}
          className="p-0 ms-2"
        />
      </div>
    </div>
  );
}

Group.propTypes = {
  group: PropTypes.object,
  user: PropTypes.object,
  onChange: PropTypes.func,
  // linkPage: PropTypes.string,
};

export default Group;
